import React from 'react'
import { useIntl } from 'react-intl'
import Modal from 'modals/dialog'

const Hero = ({ label }) => {
    const { formatMessage } = useIntl()

    return (
        <Modal.Header
            heading={formatMessage({
                id: 'emoji_action_pick',
                defaultMessage: 'Pick emoji'
            })}
            {...(!!label ? { kicker: label } : null)} />
    )
}

export default Hero